export const closets = [
  {
    id: "0001",
    name: "Roupeiros Portas de Correr",
    highlight: `/assets/closet/0001/01.jpg`,
    assets: [
      `/assets/closet/0001/01.jpg`,
      `/assets/closet/0001/02.jpg`,
      `/assets/closet/0001/03.jpg`,
      `/assets/closet/0001/04.jpg`,
    ],
  },
  {
    id: "0002",
    name: "Roupeiros Portas de Correr de Calha Oculta",
    highlight: `/assets/closet/0002/01.jpg`,
    assets: [
      `/assets/closet/0002/01.jpg`,
      `/assets/closet/0002/02.jpg`,
      `/assets/closet/0002/03.jpg`,
      `/assets/closet/0002/04.jpg`,
    ],
  },
  {
    id: "0003",
    name: "Roupeiros Portas de Batente ou Fole",
    highlight: `/assets/closet/0003/01.jpg`,
    assets: [
      `/assets/closet/0003/01.jpg`,
      `/assets/closet/0003/02.jpg`,
      `/assets/closet/0003/03.jpg`,
      `/assets/closet/0003/04.jpg`,
    ],
  },
  {
    id: "0004",
    name: "Closet / Openspace",
    highlight: `/assets/closet/0004/01.jpg`,
    assets: [
      `/assets/closet/0004/01.jpg`,
      `/assets/closet/0004/02.jpg`,
      `/assets/closet/0004/03.jpg`,
      `/assets/closet/0004/04.jpg`,
    ],
  },
  {
    id: "0005",
    name: "Projecto 01",
    highlight: `/assets/closet/0005/04.jpeg`,
    assets: [
      `/assets/closet/0005/01.jpeg`,
      `/assets/closet/0005/02.jpeg`,
      `/assets/closet/0005/03.jpeg`,
      `/assets/closet/0005/04.jpeg`,
    ],
  },
];
